import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Row } from 'react-bootstrap';

import { supports as bankSupports } from "../card/bank";
import Bank from "../card/bank";
import { supports as creditSupports } from "../card/credit";
import Credit from "../card/credit";

class Cards extends React.Component {

    constructor(props) {
        super(props);        
    }

    onSelect = (e, index) => {
        if (this.props.onSelect) this.props.onSelect(e)
    }

    onDelete = (e, index) => {
        if (this.props.onDelete) this.props.onDelete(e, index)
    }

    onOrder = (e, index) => {
        if (this.props.onOrder) this.props.onOrder(e, index)
    }

    on = (verb, e, index) => {
        switch (verb) {
            /*
            case "edit":
            case "doubleClick":
                this.onSelect(e, index);
                break;
            */
            case "delete":
                this.onDelete(e, index);
                break;
            case "order":
                this.onOrder(e, index);
                break;        
            default:
                break;
        }
    }


    render() {
        return <Row>
            {this.props.data?.map((item, index) => {
                if (bankSupports(item.accountType)) {
                    return (
                        <Bank key={`line_idx_${index}`} {...item} on={(verb, e) => { this.on(verb, e, index); }} />
                    );
                } else if (creditSupports(item.accountType)) {
                    return (
                        <Credit key={`line_idx_${index}`} {...item} on={(verb, e) => { this.on(verb, e, index); }} />
                    );
                }
            })}
        </Row>
    }
}
    
Cards.propTypes = {
    auth: PropTypes.object.isRequired
};

const mapStateToProps = (state) => {
    return ({
        auth: state.auth
    });
};

export default connect(mapStateToProps)(Cards);